export enum FinancingRequestValidityRangeTrackerName {
  ValidityRange = "ValidityRange"
}

export default FinancingRequestValidityRangeTrackerName;
